import { Component, OnInit } from '@angular/core';
import {
  BusinessRequestService,
  PipelineType, UserResponse
} from '@app/api/dmc';

interface DeviatingMeterElement {
  mainMeterId?: number;
  verificationMeterId?: number;
  meterReadingTs?: string;
  quadrant?: Quadrant;
  meteringPointIdentification?: string;
  businessTransactionId?: string;
}
import { MeteringService, Quadrant, SuppressMeterDeviation } from '@app/api/nts';
import { FormApiService } from '@app/core/services/form-api.service';
import { FormControl, FormGroup } from '@angular/forms';
import { AlertService } from '@app/core/services/alert.service';
import { HasUnsavedChanges } from '@app/core/guards/unsaved-changes.guard';

@Component({
  selector: 'app-dashboard-query-manually-handled',
  imports: [],
  templateUrl: './dashboard-query-manually-handled.component.html',
  styleUrl: './dashboard-query-manually-handled.component.css'
})
export class DashboardQueryManuallyHandledComponent implements OnInit, HasUnsavedChanges {
  public hasUnsavedChanges(): boolean {
    return this.form.dirty;
  }

  public element?: any;
  public elements?: DeviatingMeterElement[];
  public actionType?: 'deviatingMeters';

  public form: FormGroup = new FormGroup({
    pipelineType: new FormControl(PipelineType.ToDoHandled),
    updateMissingMeteredDataWhenHandled: new FormControl(true),
    serviceRequestId: new FormControl(null),
    meteringPointIdentification: new FormControl(null),
    date: new FormControl(new Date()),
    response: new FormControl(UserResponse.ManuallyHandled),
    responseReasonType: new FormControl(null),
    reasonText: new FormControl(null),
  });

  constructor(
    private readonly businessRequestService: BusinessRequestService,
    private readonly meteringService: MeteringService,
    private readonly alertService: AlertService,
    private readonly formApiService: FormApiService,
  ) {
    this.alertService.open('modal', 'info', 'dashboard.query.meteringpointchargeinformationrejected.info');
  }

  public ngOnInit(): void {
    if (this.element && this.actionType !== 'deviatingMeters') {
      this.form.patchValue({
        serviceRequestId: this.element.businessTransactionId,
        meteringPointIdentification: this.element.meteringPointIdentification,
        reasonText: 'Manually handled',
      });
    }
  }

  public submit(): void {
    if (this.actionType == 'deviatingMeters') {
      if (!this.elements?.length) {
        return;
      }

      const queryList: SuppressMeterDeviation[] = this.elements
        .filter((element) =>
          element.mainMeterId != null && element.verificationMeterId != null && element.meterReadingTs != null && element.quadrant != null
        )
        .map((element) => ({
          meterKeyA: element.mainMeterId!,
          meterKeyB: element.verificationMeterId!,
          readingTimestamp: element.meterReadingTs!,
          quadrant: element.quadrant!,
        }));

      this.formApiService.submit(
        this.form,
        (data) =>
          this.meteringService.meteringSuppressMeterDeviationsPost(queryList),
        {
          closeModal: true,
          successMessage: 'dashboard.query.meteringpointchargeinformationrejected.success',
        }
      );
    } else {
      this.formApiService.submit(
        this.form,
        (data) => this.businessRequestService.businessRequestSubmitMultiplePipelineTypeRequestPost([data]),
        {
          closeModal: true,
          successMessage: 'dashboard.query.meteringpointchargeinformationrejected.success',
        }
      );
    }
  }
}
